(() => {
	angular.module('main').filter('profilePrice', [
		'$rootScope',
		'$filter',
		'userService',
		function($rootScope, $filter, userService) {
			return function(input, type) {
				const user = userService.userData;

				let output;

				if (!input && input !== 0) {
					return '';
				}

				const inputRound = $filter('currency')(input, '');
				const money = inputRound.toString().split('.');

				const subscriptionObj = user.subscriptionPrice;

				switch (type) {
					case 'bill':
						let symbol;

						symbol = subscriptionObj.currencySymbol || '$';

						output = symbol + money[0];
						break;
					case 'coin':
						output = `.${money[1]}` || '00';
						break;
					case 'label':
						let label = subscriptionObj.currencyName || 'USD';

						if (label == 'AUD' || label == 'NZD') {
							label = 'AUD';
						}

						output = label;
						break;
					case 'full-currency-symbol':
						const symbolFull = subscriptionObj.currencySymbol || '$';
						let labelFull = subscriptionObj.currencyName || 'USD';

						if (labelFull === 'AUD' || labelFull === 'NZD') {
							labelFull = 'AUD';
						}

						output = labelFull + symbolFull + inputRound;
						break;
					case 'discount':
						const discountSymbol = subscriptionObj.currencySymbol || '$';

						if (subscriptionObj.discount.percent) {
							output = `${money[0]}%`;
						} else {
							output = discountSymbol + money;
						}
						break;
					default:
						output = '';
				}

				return output;
			};
		}
	]);
})();



// WEBPACK FOOTER //
// ./web/js/services/filters/profilePriceFilter.js